import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { useForceUpdate } from '@hooks'
import { showLoader } from '@data/state/action'
import { addCommentInCranReport } from '@data/conn/post/cranReport'
import { getCranReportById } from '@data/conn/get/cranReport'
import { CRAN_SECTION_TYPES } from '@constants'
import { InputWrapper } from '../styles'
import ProbeTextArea from '../Components/ProbeTextArea'

const dataToForm = (prevState, data) => {
	if (data === null) {
		return prevState
	}
	let _obj = data?.slice(-1)?.[0]
	return {
		...prevState,
		value: _obj?.comment,
		show_in_cran: _obj?.show_in_cran,
		comment_type: _obj?.comment_type,
		dirty: true,
	}
}

const deriveFormState = (data) => {
	const _state = {
		total_exposure: {
			label: 'Total Exposure Consolidated',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		clean_exposure: {
			label: 'Clean Exposure (if any visible)',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		exposure_nature: {
			label: 'Nature of Exposure',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		bank_nbfc_exposure: {
			label: 'Entity Exposure',
			placeholder: 'Enter Entity Exposure (Bank, NBFC, etc.) or any reason to be deduced',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
	}

	if (data) {
		_state.total_exposure = dataToForm(_state.total_exposure, data?.total_exposure)
		_state.clean_exposure = dataToForm(_state.clean_exposure, data?.clean_exposure)
		_state.exposure_nature = dataToForm(_state.exposure_nature, data?.exposure_nature)
		_state.bank_nbfc_exposure = dataToForm(_state.bank_nbfc_exposure, data?.bank_nbfc_exposure)
	}
	return _state
}
const ChargesForm = ({ probeId }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(deriveFormState())
	const loggedInUser = useSelector((state) => state.getIn(['user', 'user']))
	const [forceUpdate, update] = useForceUpdate()

	useEffect(() => {
		dispatch(showLoader(true))
		getCranReportById(probeId, [CRAN_SECTION_TYPES.CHARGES])
			.then((response) => {
				setFormState(deriveFormState(response))
			})
			.catch((error) => {
				console.log(error)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [forceUpdate])

	const updateState = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				value: value,
			},
		}))
	}

	const updateCheckHandler = (key) => (val) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				show_in_cran: val,
			},
		}))
	}

	const commentTypeHandler = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				comment_type: value,
			},
		}))
	}

	const addHandler = (key) => () => {
		let obj = formState[key]
		let comment = {
			comment: obj.value,
			comment_type: obj.comment_type,
			created_by: loggedInUser?.user_id,
			show_in_cran: obj?.show_in_cran,
		}
		dispatch(showLoader(true))
		addCommentInCranReport({
			userId: loggedInUser?.user_id,
			commentValue: comment,
			commentKey: key,
			probe42Id: probeId,
		})
			.then((response) => {})
			.catch((error) => {})
			.finally(() => {
				update()
				dispatch(showLoader(false))
			})
	}
	return (
		<>
			<DrawerBodyWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.total_exposure?.label}
						placeholder={formState?.total_exposure?.placeholder}
						toggleState={formState?.total_exposure?.comment_type}
						textValue={formState?.total_exposure?.value}
						onTextChange={updateState('total_exposure')}
						onCheckHandler={updateCheckHandler('total_exposure')}
						checkValue={formState?.total_exposure?.show_in_cran}
						onToggleChange={commentTypeHandler('total_exposure')}
						onButtonClick={addHandler('total_exposure')}
						disabled={formState?.total_exposure?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.clean_exposure?.label}
						placeholder={formState?.clean_exposure?.placeholder}
						toggleState={formState?.clean_exposure?.comment_type}
						textValue={formState?.clean_exposure?.value}
						onTextChange={updateState('clean_exposure')}
						onCheckHandler={updateCheckHandler('clean_exposure')}
						checkValue={formState?.clean_exposure?.show_in_cran}
						onToggleChange={commentTypeHandler('clean_exposure')}
						onButtonClick={addHandler('clean_exposure')}
						disabled={formState?.clean_exposure?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.exposure_nature?.label}
						placeholder={formState?.exposure_nature?.placeholder}
						toggleState={formState?.exposure_nature?.comment_type}
						textValue={formState?.exposure_nature?.value}
						onTextChange={updateState('exposure_nature')}
						onCheckHandler={updateCheckHandler('exposure_nature')}
						checkValue={formState?.exposure_nature?.show_in_cran}
						onToggleChange={commentTypeHandler('exposure_nature')}
						onButtonClick={addHandler('exposure_nature')}
						disabled={formState?.exposure_nature?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.bank_nbfc_exposure?.label}
						placeholder={formState?.bank_nbfc_exposure?.placeholder}
						toggleState={formState?.bank_nbfc_exposure?.comment_type}
						textValue={formState?.bank_nbfc_exposure?.value}
						onTextChange={updateState('bank_nbfc_exposure')}
						onCheckHandler={updateCheckHandler('bank_nbfc_exposure')}
						checkValue={formState?.bank_nbfc_exposure?.show_in_cran}
						onToggleChange={commentTypeHandler('bank_nbfc_exposure')}
						onButtonClick={addHandler('bank_nbfc_exposure')}
						disabled={formState?.bank_nbfc_exposure?.disabled}
					/>
				</InputWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default ChargesForm
